// src/components/AutoRedirect.jsx
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function AutoRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const isOnAuthPage =
      location.pathname === "/" || location.pathname === "/login";

    // ✅ Only redirect if user is logged in AND currently on "/" or "/login"
    if (user && user.category && isOnAuthPage) {
      switch (user.category.toLowerCase()) {
        case "individual":
          navigate("/dashboard/individual", { replace: true });
          break;
        case "business":
          navigate("/dashboard/business", { replace: true });
          break;
        case "vendor":
          navigate("/dashboard/vendor", { replace: true });
          break;
        case "installer":
          navigate("/dashboard/installer", { replace: true });
          break;
        default:
          navigate("/dashboard/individual", { replace: true });
      }
    }
  }, [navigate, location.pathname]);

  return null;
}

export default AutoRedirect;
